export default __webpack_public_path__ + "static/media/38.2cce9659.png";